const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeppaLogoWhiteSq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.4363 21.1824 129.2297 89.9302",
    width: "488.427px",
    height: "339.894px",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.825227
    },
    d: "M 52.438 22.226 C 39.548 23.981 24.998 26.799 14.717 35.383 C -1.494 48.917 -3.315 78.885 11.749 94.091 C 28.016 110.512 58.221 112.806 79.965 110.205 C 94.259 108.496 110.102 104.427 120.705 94.088 C 133.703 81.412 133.937 52.397 121.661 39.14 C 105.784 21.995 74.345 19.244 52.438 22.226 M 39.183 47.63 C 59.262 45.543 61.845 82.066 43.261 84.142 C 20.951 86.635 17.974 49.833 39.183 47.63 M 90.161 47.604 C 111.28 44.977 113.449 82.558 93.22 84.66 C 72.597 86.803 70.818 50.012 90.161 47.604 Z",
    id: "path1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeppaLogoWhiteSq);
export default __webpack_public_path__ + "static/media/peppa_logo_white_sq.aa8c0ce2b5beb3bd26b6e632605f8255.svg";
export { ForwardRef as ReactComponent };